import { Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React from "react"
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { MODE } from "helpers/sf_constants";
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import { optionsGarageType, optionsPropertyType, optionsTrueFalse } from "helpers/sf_lead_constants";
import NumberFormat from "react-number-format";


const AddHomeModal = ({ title, show,  onSaveHomeClick, onCloseClick }) => {


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            address: show?.mode === MODE.EDIT ? show?.values?.address : "",
            residence_type: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsPropertyType, show?.values?.residence_type) : null,
            year_built: show?.mode === MODE.EDIT ? show?.values?.year_built : "",
            sq_ft: show?.mode === MODE.EDIT ? show?.values?.sq_ft : "",
            num_bedrooms: show?.mode === MODE.EDIT ? show?.values?.num_bedrooms : "",
            garage_type: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsGarageType, show?.values?.garage_type) : null,
            num_stories: show?.mode === MODE.EDIT ? show?.values?.num_stories : "",
            num_bathrooms: show?.mode === MODE.EDIT ? show?.values?.num_bathrooms : "",
            flood_zone: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsTrueFalse, show?.values?.flood_zone) : null,
            num_residents: show?.mode === MODE.EDIT ? show?.values?.num_residents : "",
            swimming_pool: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsTrueFalse, show?.values?.swimming_pool) : null,
        },
        validationSchema: Yup.object({
            address: Yup.string(),
            residence_type: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            garage_type: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            year_built: Yup.string(),
            sq_ft: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            num_bedrooms: Yup.string(),
            num_stories: Yup.string(),
            num_bathrooms: Yup.string(),
            flood_zone: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            num_residents: Yup.string(),
            swimming_pool: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
        }),
        onSubmit: (values) => {
            onSaveHomeClick(show?.mode, {
                ...values,
                residence_type : values?.residence_type?.value,
                flood_zone : values?.flood_zone?.value,
                garage_type : values?.garage_type?.value,
                swimming_pool : values?.swimming_pool?.value
            });
        },
    });


  return (
    <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='xl'>
      <ModalHeader>
        <div className="d-flex justify-content-center">
            <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
            <span className="modal-title font-weight-semibold text-black">
                {title}
            </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
      <Form
            onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit()
                return false
            }}
        >
            <Row className="mx-2">
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Address</Label>
                        <Input
                            type='text'
                            name="address"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ''}
                            invalid={
                                !!(validation.touched.address
                                    && validation.errors.address)
                            }
                        />
                        {validation.touched.address
                            && validation.errors.address ? (
                            <FormFeedback type="invalid">
                                {validation.errors.address}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Area (sq. ft)</Label>
                        <NumberFormat
                            type="text"
                            name="sq_ft"
                            className="form-control"
                            thousandSeparator
                            onChange={(event) => {
                                const value = event.target.value.replace(",", "");
                                validation.handleChange({ ...event, 
                                  target: { 
                                    ...event.target, 
                                    value: value, 
                                    name: 'sq_ft' 
                                  } 
                                })
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.sq_ft || ''}
                            invalid={
                                !!(validation.touched.sq_ft
                                    && validation.errors.sq_ft)
                            }
                        />
                        {validation.touched.sq_ft
                            && validation.errors.sq_ft ? (
                            <FormFeedback type="invalid">
                                {validation.errors.sq_ft}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Stories</Label>
                        <NumberFormat
                            type="text"
                            name="num_stories"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_stories || ''}
                            invalid={
                                !!(validation.touched.num_stories
                                    && validation.errors.num_stories)
                            }
                        />
                        {validation.touched.num_stories
                            && validation.errors.num_stories ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_stories}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Resident(s)</Label>
                        <NumberFormat
                            type="text"
                            name="num_residents"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_residents || ''}
                            invalid={
                                !!(validation.touched.num_residents
                                    && validation.errors.num_residents)
                            }
                        />
                        {validation.touched.num_residents
                            && validation.errors.num_residents ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_residents}
                            </FormFeedback>
                        ) : null}
                    </Col>
                </Col>
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Residence Type</Label>
                        <Select
                            menuPortalTarget={document.body} 
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={optionsPropertyType}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'residence_type',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'residence_type' },
                                });
                            }}
                            value={validation.values.residence_type || null}
                            invalid={
                                !!(validation.touched.residence_type
                                    && validation.errors.residence_type)
                            }
                        />
                        {validation.touched.residence_type
                            && validation.errors.residence_type ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Bedroom(s)</Label>
                        <NumberFormat
                            type="text"
                            name="num_bedrooms"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_bedrooms || ''}
                            invalid={
                                !!(validation.touched.num_bedrooms
                                    && validation.errors.num_bedrooms)
                            }
                        />
                        {validation.touched.num_bedrooms
                            && validation.errors.num_bedrooms ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_bedrooms}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Bathroom(s)</Label>
                        <NumberFormat
                            type="text"
                            name="num_bathrooms"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.num_bathrooms || ''}
                            invalid={
                                !!(validation.touched.num_bathrooms
                                    && validation.errors.num_bathrooms)
                            }
                        />
                        {validation.touched.num_bathrooms
                            && validation.errors.num_bathrooms ? (
                            <FormFeedback type="invalid">
                                {validation.errors.num_bathrooms}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Swimming Pool</Label>
                        <Select
                            menuPortalTarget={document.body} 
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={optionsTrueFalse}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'swimming_pool',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'swimming_pool' },
                                });
                            }}
                            value={validation.values.swimming_pool || null}
                            invalid={
                                !!(validation.touched.swimming_pool
                                    && validation.errors.swimming_pool)
                            }
                        />
                        {validation.touched.swimming_pool
                            && validation.errors.swimming_pool ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                </Col>
                <Col md={4} className='pe-3'>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Year Built</Label>
                        <NumberFormat
                            type="text"
                            name="year_built"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.year_built || ''}
                            invalid={
                                !!(validation.touched.year_built
                                    && validation.errors.year_built)
                            }
                        />
                        {validation.touched.year_built
                            && validation.errors.year_built ? (
                            <FormFeedback type="invalid">
                                {validation.errors.year_built}
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Garage</Label>
                        <Select
                            menuPortalTarget={document.body} 
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={optionsGarageType}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'garage_type',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'garage_type' },
                                });
                            }}
                            value={validation.values.garage_type || null}
                            invalid={
                                !!(validation.touched.garage_type
                                    && validation.errors.garage_type)
                            }
                        />
                        {validation.touched.garage_type
                            && validation.errors.garage_type ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                    <Col className="mb-3">
                        <Label className="font-weight-semibold">Flood Zone</Label>
                        <Select
                            menuPortalTarget={document.body} 
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={optionsTrueFalse}
                            onChange={(selectedOption) => {
                                const event = {
                                    target: {
                                        name: 'flood_zone',
                                        value: selectedOption,
                                    },
                                };
                                validation.handleChange(event);
                            }}
                            onBlur={() => {
                                validation.handleBlur({
                                    target: { name: 'flood_zone' },
                                });
                            }}
                            value={validation.values.flood_zone || null}
                            invalid={
                                !!(validation.touched.flood_zone
                                    && validation.errors.flood_zone)
                            }
                        />
                        {validation.touched.flood_zone
                            && validation.errors.flood_zone ? (
                            <span className="text-danger">
                                {CONSTANTS.STR_REQUIRED_FIELD}
                            </span>
                        ) : null}
                    </Col>
                </Col>
            </Row>
            <Row>
                <div className="text-end mt-3">
                    <button
                        type="submit"
                        name="submit"
                        className={`btn ${getPrimaryButtonClass()} ms-2`}
                    >
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-light ms-2"
                        onClick={onCloseClick}
                    >
                        Cancel
                    </button>
                </div>
            </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

AddHomeModal.propTypes = {
  onCloseClick: PropTypes.func,
  onSaveHomeClick: PropTypes.func,
  show: PropTypes.any,
  title: PropTypes.any,
}

export default AddHomeModal;

